import { useEffect, useState } from 'react';
import { apiClient } from '@/api/client';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import TESTIDS from '@/constants/testIds';

export default function AuditLogs() {
    const [logs, setLogs] = useState([]);
    const [q, setQ] = useState('');

    const load = async () => {
        const params = {};
        if (q.trim()) params.q = q.trim();
        const r = await apiClient.get('/audit/logs', { params });
        setLogs(r.data);
    };

    useEffect(() => {
        const t = setTimeout(load, 200);
        return () => clearTimeout(t);
    }, [q]);

    return (
        <div className="space-y-4">
            <div className="flex items-end justify-between">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Audit logs</h1>
                    <p className="text-sm text-muted-foreground">Every operator action, every safety event — immutable, searchable.</p>
                </div>
                <div className="w-[280px]">
                    <Input
                        placeholder="Search action, actor, target…"
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        data-testid={TESTIDS.auditSearchInput}
                    />
                </div>
            </div>
            <Card className="border-border bg-card">
                <div className="hidden grid-cols-[160px_180px_1fr_160px_120px] gap-3 border-b border-border px-4 py-2 text-[11px] font-medium uppercase tracking-wider text-muted-foreground md:grid">
                    <div>Timestamp</div>
                    <div>Actor</div>
                    <div>Action</div>
                    <div>Target</div>
                    <div>Result</div>
                </div>
                <ul className="divide-y divide-border">
                    {logs.length === 0 ? (
                        <li className="p-6 text-sm text-muted-foreground">No matching audit entries.</li>
                    ) : null}
                    {logs.map((l) => (
                        <li
                            key={l.id}
                            className="grid grid-cols-1 gap-2 px-4 py-2 text-xs md:grid-cols-[160px_180px_1fr_160px_120px]"
                            data-testid={TESTIDS.auditRow}
                        >
                            <div className="font-mono text-[11px] text-muted-foreground">{new Date(l.timestamp).toLocaleString()}</div>
                            <div className="font-mono">{l.actor}</div>
                            <div>
                                <span className="font-medium">{l.action}</span>
                                {l.details && Object.keys(l.details).length ? (
                                    <div className="font-mono text-[10px] text-muted-foreground">{JSON.stringify(l.details)}</div>
                                ) : null}
                            </div>
                            <div className="font-mono text-[11px] text-muted-foreground">
                                {l.target_type}
                                {l.target_id ? <span>:{(l.target_id + '').slice(0, 8)}…</span> : null}
                            </div>
                            <div>
                                <span className="rounded-md border border-border bg-[hsl(var(--surface-2))] px-1.5 py-0.5 text-[10px] uppercase tracking-wider text-muted-foreground">
                                    {l.result}
                                </span>
                            </div>
                        </li>
                    ))}
                </ul>
            </Card>
        </div>
    );
}
